/*
 *
 * Settings constants
 *
 */

export const SLICE_NAME = 'settingsSlice';
